import { ArticleParagraph1 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './styles.css';
import { PIK_LANDING_PATH } from '../../constants/common';

export interface IPikPromoBannerProps {
  onClick(): void;
}

export function PikPromoBanner({ onClick }: IPikPromoBannerProps) {
  return (
    <div className={styles['container']}>
      <a href={PIK_LANDING_PATH} className={styles['promo-block']} onClick={onClick}>
        <ArticleParagraph1 color="white_100" fontWeight="bold">
          Районы, продуманные
          <br />
          до мелочей
        </ArticleParagraph1>
        <div className={styles['pik-logo']} />
      </a>
    </div>
  );
}
